import React from "react";
import { Link } from "react-router-dom";
import "./HrService.css";
import { ReactComponent as ArrowRight } from "../../assets/developementservices/arrow-right.svg";
import { ReactComponent as Icon1 } from "../../assets/hr/HRStrategyandPlanning.svg";
import { ReactComponent as Icon2 } from "../../assets/hr/HRPolicyDevelopment.svg";
import { ReactComponent as Icon3 } from "../../assets/hr/RecruitmentandSelection.svg";
import { ReactComponent as Icon4 } from "../../assets/hr/EmployeeOnboarding.svg";
import { ReactComponent as Icon5 } from "../../assets/hr/TrainingandDevelopment.svg";
import { ReactComponent as Icon6 } from "../../assets/hr/EmployeeEngagement.svg";
import { ReactComponent as Icon7 } from "../../assets/hr/HRCompliance.svg";
import { ReactComponent as Icon8 } from "../../assets/hr/PayrollManagement.svg";
import HandshakeImage from "../../assets/developementservices/handshake.png";
import { AnimatedButton } from "../common/AnimatedButton";

const HrService = () => {
  const services = [
    {
      title: "HR Strategy And Planning",
      description:
        "We assist companies in aligning their HR strategies with organizational objectives, ensuring smooth and efficient personnel planning, performance management, and retention of talent. ",
      Icon: Icon1,
    },
    {
      title: "HR Policy Development",
      description:
        "Regulations that guard the company and value employees. We create custom HR policies that are fair, follow the rules, work smoothly, and match what’s best in the industry. ",
      Icon: Icon2,
    },
    {
      title: "Recruitment And Selection",
      description:
        "Our specialized recruitment services find and attract top talent using systematic selection processes to ensure the best fit for your company.",
      Icon: Icon3,
    },
    {
      title: "Employee Onboarding",
      description:
        "Efficient and smooth onboarding programs to welcome new employees into your company culture, enhancing productivity and engagement from day one. ",
      Icon: Icon4,
    },
    {
      title: "Training And Development",
      description:
        "We create fair and effective HR policies based on legal and industry standards. We also train both HR and employees to improve skills, boost performance, and support professional growth.",
      Icon: Icon5,
    },
    {
      title: "Employee Engagement",
      description:
        "Tactics and initiatives aimed at elevating employee morale, motivation, and productivity and setting the groundwork for sustained business prosperity.",
      Icon: Icon6,
    },
    {
      title: "HR Compliance",
      description:
        "We maintain your business up to code in employment laws and HR regulations reducing exposure and ensuring a healthy, lawfully compliant environment at work.",
      Icon: Icon7,
    },
    {
      title: "Payroll Management",
      description:
        "Comprehensive payroll services with complete accuracy, timelines in processing salaries, tax adherence, and finance management for an uncomplicated payroll process.",
      Icon: Icon8,
    },
  ];

  return (
    <div>
      {/* Hero Section */}
      <section className="hero-section1">
        <div className="hero-content">
          <h1>
            Your HR Partner for <span className="bold1">Smarter People</span>{" "}
            Management.
          </h1>
          <p>Our HR services make your business, and your people, flourish.</p>
          {/* <Link to="/contact" className="free-consult-btn">
            <span className="btn-text">Get Free Consultation</span>
              <span className="btn-circle">
                <ArrowRight className="arrow-icon" />
              </span>
          </Link> */}
          <AnimatedButton link="/contact" label="Get Free Consultation" />
        </div>
      </section>

      {/* HR Services Grid */}
      <section className="hr-services-section">
        <h2 className="section-title">
          <span className="white-text">Webbunny </span>
          <span className="bold1">HR Consulting</span>
          <span className="white-text"> Services</span>
        </h2>
        <p className="section-subtitle">
          Take your HR processes to the next level with tools built for
          efficiency, simplicity, and growth.
        </p>

        <div className="services-grid">
          {services.map((service, index) => {
            const { title, description, Icon } = service;
            return (
              <div className="service-card" key={index}>
                <Icon className="icon" />
                <span className="card-number">
                  {String(index + 1).padStart(2, "0")}
                </span>
                <p className="card-title">{title}</p>
                <p className="description">{description}</p>
              </div>
            );
          })}
        </div>
      </section>

      <section
        className="cta-hrsection"
        style={{ background: "none", backgroundColor: "#ffffff" }}
      >
        <div className="cta-content">
          <div className="cta-text">
            <h2>Ready To Create A Happier, High-Performing Team?</h2>
            <Link to="/contact" className="cta-button">
              Let’s Connect
            </Link>
          </div>
          <div className="cta-image">
            <img src={HandshakeImage} alt="Handshake Illustration" />
          </div>
        </div>
      </section>
    </div>
  );
};

export default HrService;
